const embeddedBinaryPattern =
  /(<(?:[\w.-]+:)?EmbeddedDocumentBinaryObject\b[^>]*>)([\s\S]*?)(<\/(?:[\w.-]+:)?EmbeddedDocumentBinaryObject>)/gi;

export const sanitizeUblXmlForDisplay = (xml: string): string =>
  xml.replace(
    embeddedBinaryPattern,
    '$1[… ingesloten document …]$3',
  );

const prettyPrintXml = (xml: string): string => {
  const compact = xml.replace(/>\s+</g, '><').trim();
  if (!compact) {
    return compact;
  }

  let formatted = '';
  let pad = 0;
  const nodes = compact.split(/(?=<)/);

  nodes.forEach(node => {
    if (!node) {
      return;
    }

    if (/^<\//.test(node)) {
      pad = Math.max(pad - 1, 0);
    }

    formatted += `${'  '.repeat(pad)}${node}\n`;

    if (
      /^<[^!?/]/.test(node)
      && !/\/>$/.test(node)
      && !/^<(?:[\w.-]+:)?EmbeddedDocumentBinaryObject\b/.test(node)
    ) {
      pad += 1;
    }
  });

  return formatted.trim();
};

export const formatUblXmlForDisplay = (xml: string): string => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'text/xml');

    if (doc.querySelector('parsererror')) {
      return prettyPrintXml(sanitizeUblXmlForDisplay(xml));
    }

    return prettyPrintXml(sanitizeUblXmlForDisplay(xml));
  } catch {
    return sanitizeUblXmlForDisplay(xml);
  }
};
